<div id="popup-camera-pic" class="popup-overlay modal-camera">
  <div class="popup-warp">
      <div class="popup-inner">
          <select class="device" (change)="onDeviceSelectChange($event.target.value)">
            <option>No device</option>
            <option *ngFor="let dev of availableDevices" [value]="dev.deviceId" [selected]="dev.deviceId == deviceSelected">{{dev.label}}</option>
          </select>
          <div class="content-popup pad-popup">
              <p class="name-QRcode">Scan QR Code của khách hàng</p>
              <div class="picture-bill QRCode" id="imageContainer">
                <zxing-scanner [torch]="torchEnabled" [device]="deviceCurrent" (deviceChange)="onDeviceChange($event)" (scanSuccess)="onCodeResult($event)"
                  [formats]="formatsEnabled" (permissionResponse)="onHasPermission($event)"
                  (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)">
                </zxing-scanner>
              </div>
              <div class="text-barcode" *ngIf="displayCode">
                <p>Hoặc</p>
                <p class="name-code">Nhập mã code</p>
                <div class="form-field">
                  <input type="text"  
                    class="form-control" 
                    [maxlength]="codeLen" 
                    [placeholder]="placeHolder" 
                    (keypress)="codeKeyPress($event)"
                    (keyup)="enterBarcodeChange($event)" 
                    [(ngModel)]="qrResultString"/>
                </div>
              </div>           
              <div class="group-btn-inline-3">
                <button type="button" class="btn btn-block btn-primary" (click)="closeScanner()">Đóng</button>
            </div>
          </div>
      </div>
  </div>
</div>
<message-popup *ngIf="showMessageBox" [message]="message" (closeEvent)="closeMessagePopupEvent()"></message-popup>
